import React, {FC} from "react";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportSummeryItemTransaction} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportSummeryItemTransactionPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: getSystemLanguageId(), userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportSummeryItemTransaction}
            searchHeader={getPageNameByPageId(PageEnum.ReportSummeryItemsTransaction)}
            SearchPanel={ReportItemsSearchPanel}
            formId={PageEnum.ReportSummeryItemsTransaction}
        />
    );
};
